import { GenericModelApi } from "./GenericModelApi";
import { ApiClient, ApiError, ApiSchema, FetchResponse } from "./ApiClient";
import { RecibeFormData, RecibeRelatedAttributes } from "@/formTypes/RecibeDataType";
import { RecibeFormDataKeys } from "@/generated/RecibeFormDataKeys";
import { generateNextNumberByModel } from "@utils/Utils";
import { stampCreatorUser } from "@utils/Auth";
import { DocumentAutoGeneratedNumberApi } from "./DocumentAutoGeneratedNumberApi";

export type RecibeDataType = Partial<ApiSchema["Recibe"]["type"] & RecibeFormData>;

class Api extends GenericModelApi<"Recibe", RecibeDataType> {
    protected userSortKeyDateField = "created" as const
    /** Se crea desde el frontend, así que la etiqueta del creador se estampa aquí. */
    protected stampsCreatorUser = true


    async fetchAll(filters: any = {}, token?: string, limit: number = 20): Promise<FetchResponse<RecibeDataType>> {
        const selectionSet = [
            ...RecibeFormDataKeys.filter(k => !RecibeRelatedAttributes.includes(k)),
            "currency.*",
            "client.*",
        ]

        return super.fetchAll(filters, token, limit, selectionSet);
    }

    async createClientRecibe(input: RecibeDataType): Promise<RecibeDataType> {
        let inputData = { ...input }
        let generatedNumber
        if (!inputData?.numero) {
            generatedNumber = await generateNextNumberByModel("Recibe");
            if (!generatedNumber?.number) {
                throw Error(`No fue posible generar el identificador del Recibo`)
            }
            inputData = {
                ...inputData,
                numero: `${generatedNumber?.number}`
            }
        }

        // No pasa por `this.create()`, así que la bandera `stampsCreatorUser` no aplica aquí.
        const { data, errors } = await ApiClient.models["Recibe"].create(await stampCreatorUser(inputData));

        if (errors) {
            throw new ApiError(`Errores al crear El recibo`, "API_ERROR", errors);
        }

        if (generatedNumber) {
            await DocumentAutoGeneratedNumberApi.save(generatedNumber)
        }

        return data || {} as TDataType;
    }

}
export const RecibeApi = new Api("Recibe", "numero", "DESC", "created", "listRecibeByCreatedTenant")